<div class="container">
  <section class="hero mb-lg">
    <span class="hero-eyebrow">Testimonials</span>
    <h1>What Our Users Say</h1>
    <p>
      Real feedback from people who've used our calculators and services. Used something here and
      it helped? Share your experience below — every submission is reviewed before it appears.
    </p>
  </section>

  <section class="card mb-lg">
    <h2 class="section-title">Reviews</h2>

    @if (loadingTestimonials()) {
      <p class="testimonials-hint">Loading reviews…</p>
    } @else if (testimonials().length === 0) {
      <p class="testimonials-hint">No reviews yet — be the first to share your experience.</p>
    } @else {
      <div class="testimonial-grid">
        @for (t of testimonials(); track t.id) {
          <div class="testimonial-card">
            <div class="testimonial-stars" aria-hidden="true">
              @for (star of stars; track star) {
                <span class="star" [class.filled]="star <= t.rating">★</span>
              }
            </div>
            <p class="testimonial-message">"{{ t.message }}"</p>
            <div class="testimonial-author">
              <span class="testimonial-name">{{ t.name }}</span>
              @if (t.role) {
                <span class="testimonial-role">{{ t.role }}</span>
              }
            </div>
          </div>
        }
      </div>
    }
  </section>

  @if (submitted()) {
    <section class="card success-card mb-lg">
      <div class="success-icon" aria-hidden="true"></div>
      <h2 class="section-title">Thanks for sharing</h2>
      <p>
        Your testimonial has been received and is pending review — it'll appear here once
        approved. Meanwhile, feel free to keep exploring our
        <a routerLink="/">free calculators</a>.
      </p>
    </section>
  } @else {
    <section class="card mb-lg">
      <h2 class="section-title">Share your experience</h2>

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="field-row-2">
          <div class="field-group" [class.has-error]="hasError('name')">
            <label class="field-label" for="testimonial-name">Your Name</label>
            <div class="input-shell">
              <input id="testimonial-name" type="text" formControlName="name"
                placeholder="e.g. Asha Sharma" autocomplete="name" maxlength="120" />
            </div>
            @if (hasError('name')) {
              <div class="field-error">Please enter your name.</div>
            }
          </div>

          <div class="field-group">
            <label class="field-label" for="testimonial-role">Role / Company (optional)</label>
            <div class="input-shell">
              <input id="testimonial-role" type="text" formControlName="role"
                placeholder="e.g. Software Engineer, Bangalore" maxlength="120" />
            </div>
          </div>
        </div>

        <div class="field-group" [class.has-error]="hasError('rating')">
          <!-- Group heading for the star-rating buttons below, wired via aria-labelledby (not a single-control label) -->
          <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
          <label class="field-label" id="testimonial-rating-label">Rating</label>
          <div class="stars" role="group" aria-labelledby="testimonial-rating-label" (mouseleave)="hoverRating.set(0)">
            @for (star of stars; track star) {
              <button
                type="button"
                class="star-button"
                (click)="setRating(star)"
                (mouseenter)="hoverRating.set(star)"
                [attr.aria-label]="star + ' star' + (star > 1 ? 's' : '')"
              >
                <span class="star" [class.filled]="star <= (hoverRating() || form.controls.rating.value)">★</span>
              </button>
            }
          </div>
          @if (hasError('rating')) {
            <div class="field-error">Please choose a rating.</div>
          }
        </div>

        <div class="field-group" [class.has-error]="hasError('message')">
          <label class="field-label" for="testimonial-message">Your testimonial</label>
          <textarea id="testimonial-message" class="testimonial-textarea" formControlName="message"
            rows="5" placeholder="Tell us about your experience…" maxlength="2000"></textarea>
          @if (hasError('message')) {
            <div class="field-error">Please enter your testimonial.</div>
          }
        </div>

        <!-- Cloudflare Turnstile: proves the sender is human before we accept the form. -->
        <div class="captcha-row">
          <div id="testimonials-turnstile"></div>
          @if (!captchaReady()) {
            <p class="captcha-hint">Loading the human-verification check…</p>
          }
        </div>

        @if (errorMessage()) {
          <div class="form-error-hint">{{ errorMessage() }}</div>
        }

        <button type="submit" class="btn btn-primary testimonial-submit"
          [disabled]="submitting()">
          @if (submitting()) {
            <span class="spinner"></span> Sending…
          } @else {
            Submit testimonial
          }
        </button>
      </form>
    </section>
  }
</div>
